/**
 * OpenAI API service
 * Service for making requests to OpenAI's API via our backend
 */
import fetchApi from '../fetchApi'

/**
 * Generate a response using OpenAI's chat completions API
 * 
 * @param {Array} messages - Array of message objects with role and content
 * @param {Object} options - Additional options
 * @returns {Promise} - Promise resolving to the generated response
 */
export const generateChatCompletion = (messages, {
  model = 'gpt-4o-mini',
  temperature = 0.7,
  maxTokens = 500,
  fetchController = null,
} = {}) => {
  const data = {
    model,
    messages,
    temperature,
    max_tokens: maxTokens,
  }

  return fetchApi('/ai/chat-completions', 'POST', {
    body: JSON.stringify(data),
    fetchController
  }).then(response => {
    if (response && response.generatedText) {
      return response.generatedText
    }
    throw new Error('No valid response from AI service')
  })
}

// Export the named functions
export default {
  generateChatCompletion
} 



// WEBPACK FOOTER //
// ./src/services/openai-api/index.js